export const BusinessCardsData = [
  {
    id: 1,
    name: `Hospitality`,
    img: `img/live-demo/business/hospitality.svg`,
    prompt: "Hello and welcome to our hotel! I'm your front desk assistant here to make your stay comfortable. I can help you with room bookings, amenities, check-in/check-out timings, and answer any questions about our services or local attractions. How can I assist you today?"
  },
  {
    id: 2,
    name: `Healthcare`,
    img: `img/live-demo/business/healthcare.svg`,
    prompt: "Hi there! I'm your virtual assistant for our multispecialty clinic. I'm here to help you book appointments, provide information on our services including dental and diagnostics, and assist with clinic hours or insurance queries. How can I support you today?"
  },
  {
    id: 3,
    name: `Real Estate`,
    img: `img/live-demo/business/realestate.svg`,
    prompt: "Hello! I'm your real estate assistant, here to guide you through your property search. I can help with location and budget preferences, answer questions about available listings, and schedule site visits. What are you looking for today?"
  },
  {
    id: 4,
    name: `Gaming`,
    img: `img/live-demo/business/gaming.svg`,
    prompt: "Hey gamer! I'm your support assistant for the gaming platform. I can help you with account setup, password recovery, payment options, and explain game rules or features. Ready to get started?"
  },
  {
    id: 5,
    name: `Restaurant`,
    img: `img/live-demo/business/food.svg`,
    prompt: "Hi there! I’m your reservation assistant for our restaurant chain. I'm here to help you check table availability, make bookings, explore our menu, or answer questions about dietary options and hours. How can I help with your reservation today?"
  },
  {
    id: 6,
    name: `L&D Training`,
    img: `img/live-demo/business/education.svg`,
    prompt: "Hello! I'm your HR assistant from the corporate training team. I'm here to provide info on upcoming programs, assist you with registration, and answer questions about modules, schedules, or certifications. What would you like to know today?"
  }
];